import { render, staticRenderFns } from "./AdvancedWrapper.vue?vue&type=template&id=61304bf2&"
import script from "./AdvancedWrapper.vue?vue&type=script&lang=js&"
export * from "./AdvancedWrapper.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports